$(document).ready(() => {
    // Create cookie on click
    $('.js-cookieBar button').click(() => {
        Cookies.set('cookies-notification', 1, {expires: 365 * 10, path: '/'});
        $('.js-cookieBar').hide();
    });
    // Check if there is cookie already, if not show the notification (to prevent when hidden on client but not yet on client).
    if (!Cookies.get('cookies-notification')) {
        $('.cookies-notification').show();
    }
});
